// extracted by mini-css-extract-plugin
export default {"screen":"GuideImg_screen__nBf1W","imgTag":"GuideImg_imgTag__TdwQc"};